import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4851bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-cols-1 row-cols-md-3 g-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RestorantCard = _resolveComponent("RestorantCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restorants, (restorant) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col",
        key: restorant.id
      }, [
        _createVNode(_component_RestorantCard, { restorant: restorant }, null, 8, ["restorant"])
      ]))
    }), 128))
  ]))
}